"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperButton = exports.SmallPopup = exports.ExportDataSmallPopup = exports.ConfirmationPopup = void 0;
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const WrapperButton = styled_components_1.default.div `
  display: flex;
  position: relative;
`;
exports.WrapperButton = WrapperButton;
const SmallPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;
  height: auto;

  &-overlay {
  }

  &-content {
    width: 200px;
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 8px;
    position: relative;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 6;
    display: flex;
  }
`;
exports.SmallPopup = SmallPopup;
const ExportDataSmallPopup = (0, styled_components_1.default)(SmallPopup) `
  &-content {
    width: 180px;
  }
`;
exports.ExportDataSmallPopup = ExportDataSmallPopup;
const ConfirmationPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  &-content {
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1200;
    display: flex;
  }
`;
exports.ConfirmationPopup = ConfirmationPopup;
